export function normalizeSchoolIds(schools) {
  if (!schools) return [];
  if (Array.isArray(schools)) return schools.map((s) => String(s));
  if (typeof schools === 'string') {
    try {
      const parsed = JSON.parse(schools);
      return Array.isArray(parsed) ? parsed.map((s) => String(s)) : [];
    } catch {
      return [];
    }
  }
  return [];
}

export function getDefaultAccessCard(userData) {
  if (!userData?.accesscards || !userData.default_accesscard_id) return null;
  return (
    userData.accesscards.find((ac) => ac.accesscard_id === userData.default_accesscard_id) || null
  );
}

export function eventInUserScope(userData, event) {
  const card = getDefaultAccessCard(userData);
  if (!card) return false;
  if (card.global === true) return true;

  const schoolId = card.school_id ?? card.school?.school_id;
  if (!schoolId) return false;

  const allowAll =
    event.allowallschools === true ||
    event.allowAllSchools === true ||
    event.allow_all_schools === true;
  if (allowAll) return true;

  const schoolIds = normalizeSchoolIds(event.schools);
  return schoolIds.includes(String(schoolId));
}

/** My Events open-SAF icon — one capability; view/edit decided on the SAF Form page. */
export function canMyEventsOpenSAFForm(event, openSAFForm, userData) {
  if (!openSAFForm || !eventInUserScope(userData, event)) return false;
  if (event.stage === 'request') return event.status === 'approved';
  return event.stage === 'saf' || event.stage === 'official';
}
